import React, { useState, useCallback } from "react";
import { Form } from "semantic-ui-react";
import { producaov2 as api } from "../../../../../services/apis";

import swal from "sweetalert";
import { StyledLabel, StyledButton } from "./styles";
import AlunoSearchInputMultiple from "../../../AlunoSearchInputMultiple";
import CursoSearchInputMultiple from "../../../CursoSearchInputMultiple";
import { useRouter } from "../../../../../hooks/router";

const Formulario = () => {
  const [emailList, setEmailList] = useState([]);
  const [courseList, setCourseList] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedAlunos, setSelectedAlunos] = useState([]);
  const [selectedCursos, setSelectedCursos] = useState([]);

  const handleAlunoChange = useCallback(
    (e, { options, value }) => {
      const email = options.find((option) => option.key === value[1]);

      setSelectedAlunos((prev) => {
        if(email) {
          return [
            ...prev,
            { id: email.key, email: email.text },
          ];
        }

        return prev;
      });
    },
    [selectedAlunos]
  );

  const handleCursoChange = useCallback(
    (e, { options, value }) => {
      const curso = options.find((option) => option.key === value[1]);

      setSelectedCursos((prev) => {
        if(curso) {
          return [
            ...prev,
            { id: curso.key, curso: curso.text },
          ];
        }

        return prev;
      });
    },
    [selectedCursos]
  );

  const router = useRouter();

  const createTrail = useCallback(async () => {
    try {
      const payload = {
        ids_pessoa: selectedAlunos.map(aluno => aluno.id),
        course_ids: selectedCursos.map(curso => curso.id),
        title: name,
        description,
      };
      await api.post("admin/incompany/v3/trails", payload);
      swal("Trilha criada com sucesso ", "", "success");
      setTimeout(() => router.push("/admin/trilhas/listar"), 2000);
    } catch (err) {
      console.error(err);
      swal("Erro ao fazer a solicitação", "Favor contatar TI", "error");
    }
  }, [name, description, emailList, courseList, selectedAlunos, selectedCursos]);

  const createTrails = useCallback(async () => {
    createTrail();
  }, [name, description, emailList, courseList, createTrail, selectedAlunos, selectedCursos]);

  return (
    <Form>
      <Form.Field>
        <StyledLabel>Nome da trilha </StyledLabel>
        <Form.Input
          name="name"
          placeholder="Trilha de tecnologia ALLIN"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Descrição da trilha </StyledLabel>
        <Form.Input
          name="description"
          placeholder="Trilha dedicada a pessoas com forte capacidade cognitiva"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <CursoSearchInputMultiple handleChange={handleCursoChange} selectedCursos={selectedCursos} setSelectedCursos={setSelectedCursos} />
      </Form.Field>
      <Form.Field>
        <AlunoSearchInputMultiple
          handleChange={handleAlunoChange}
          selectedAlunos={selectedAlunos}
          setSelectedAlunos={setSelectedAlunos}
          naoAllIn={true}
        />
      </Form.Field>
      <StyledButton onClick={createTrails}>
        <i class="plus icon"></i> Criar
      </StyledButton>
    </Form>
  );
};

export default Formulario;
